// Chakra imports
import {
  Flex,
  Stat,
  Text,
  StatLabel,
  StatNumber,
  useColorModeValue,
} from "@chakra-ui/react";
// Custom components
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import IconBox from "components/Icons/IconBox";
import React from "react";

const MiniStatistics = ({ title, amount, percentage, icon }) => {
  const iconTeal = useColorModeValue("teal.300", "teal.300");
  const textColor = useColorModeValue("gray.700", "white");

  return (
    <Card minH='83px'>
      <CardBody>
        <Flex flexDirection='row' align='center' justify='center' w='100%'>
          <Stat me='auto'>
            <StatLabel
              fontFamily='Inter'
              fontSize='sm'
              color='gray.400'
              fontWeight='bold'
              pb='.1rem'>
              {title}
            </StatLabel>
            
              <StatNumber fontSize='lg' color={textColor}>
                {amount.toLocaleString()} USD
                {percentage !== undefined &&
                  <Text as={'span'} color={percentage >= 0 ? "green.400" : "red.400"} > ({percentage.toLocaleString()}%)</Text>
                }
              </StatNumber>
              
            
          </Stat>
        </Flex>
      </CardBody>
    </Card>
  );
};

export default MiniStatistics;
